import { apiClient } from './apiClient';

export const processService = {
    createCessao: async (cpf, processoId = null, percentual = 100.0) => {
        const response = await apiClient.post('/cedentes/cessao', {
            cpf: cpf,
            processo_id: processoId,
            percentual: percentual
        });
        return response.data;
    },

    getProcessos: async () => {
        const response = await apiClient.get('/processos');
        return response.data;
    },

    createProcesso: async (data) => {
        const response = await apiClient.post('/processos', data);
        return response.data;
    },

    updateProcesso: async (id, data) => {
        const response = await apiClient.put(`/processos/${id}`, data);
        return response.data;
    },

    deleteProcesso: async (id) => {
        const response = await apiClient.delete(`/processos/${id}`);
        return response.data;
    },

    addProcessoDocumento: async (processoId, data) => {
        const response = await apiClient.post(`/processos/${processoId}/documentos`, data);
        return response.data;
    },

    updateProcessoDocumento: async (processoId, docId, data) => {
        const response = await apiClient.put(`/processos/${processoId}/documentos/${docId}`, data);
        return response.data;
    },

    removeProcessoDocumento: async (processoId, docId) => {
        const response = await apiClient.delete(`/processos/${processoId}/documentos/${docId}`);
        return response.data;
    },

    addProcessoSigner: async (processoId, data) => {
        const response = await apiClient.post(`/processos/${processoId}/signers`, data);
        return response.data;
    },

    removeProcessoSigner: async (processoId, signerId) => {
        const response = await apiClient.delete(`/processos/${processoId}/signers/${signerId}`);
        return response.data;
    },

    getProcessoCedentes: async (processoId, search = "", limit = 50, offset = 0) => {
        const params = new URLSearchParams({ limit, offset });
        if (search) params.append("search", search);
        const response = await apiClient.get(`/processos/${processoId}/cedentes?${params.toString()}`);
        return response.data;
    },

    exportProcessoCedentesCSV: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/export`, { responseType: "blob" });
        return response.data;
    },

    linkCedentesBulk: async (processoId, payload) => {
        const response = await apiClient.post(`/processos/${processoId}/cedentes/bulk`, payload);
        return response.data;
    },

    linkCedente: async (processoId, payload) => {
        const response = await apiClient.post(`/processos/${processoId}/cedentes`, payload);
        return response.data;
    },

    unlinkCedente: async (processoId, cedenteId) => {
        const response = await apiClient.delete(`/processos/${processoId}/cedentes/${cedenteId}`);
        return response.data;
    },

    unlinkCedentesBulk: async (processoId, cedenteIds) => {
        const response = await apiClient.delete(`/processos/${processoId}/cedentes/bulk`, {
            data: { cedente_ids: cedenteIds }
        });
        return response.data;
    },

    checkDeletedLink: async (processoId, cedenteId) => {
        const response = await apiClient.get(`/processos/${processoId}/cedentes/${cedenteId}/check-deleted`);
        return response.data;
    },

    getDashboardStats: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/dashboard`);
        return response.data;
    },

    bulkStatusUpdate: async (file, processoId = null) => {
        const formData = new FormData();
        formData.append('file', file);
        
        let url = '/processos/status-bulk';
        if (processoId) {
            url += `?processo_id=${processoId}`;
        }

        const response = await apiClient.post(url, formData);
        return response.data;
    }
};
